import React from 'react';
import { ButtonV2 } from '@zola/zola-ui/src/components/Button';
import { CircleIcon } from '@zola/zola-ui/src/components/CircleIcon';
import { WeddingWebsites } from '@zola/zola-ui/src/assets/images/icons';
import { connect } from 'react-redux';
import { hideModal } from 'cards/actions/modalActions';
import styles from './styles.module.less';

const PublishWeddingWebsite = ({ onCancel, onConfirm }) => (
  <div className={styles.container}>
    <CircleIcon image={WeddingWebsites} size={100} variant="cream" />
    <div className={styles.header}>Ready to publish?</div>
    <div className={styles.content}>
      Let&lsquo;s get this show on the road! (Err, web?) You&lsquo;ll still be able to edit your
      website while it&lsquo;s live, and can switch it back off at any time.
    </div>
    <div className={styles.buttonContainer}>
      <ButtonV2 onClick={onCancel}>Not Yet</ButtonV2>
      <ButtonV2 onClick={onConfirm}>Let&lsquo;s Do It</ButtonV2>
    </div>
  </div>
);

const mapDispatchToProps = dispatch => ({
  onConfirm: () => {
    dispatch(hideModal());
    window.open('/wedding/manage/website/manage', '_blank');
  },
  onCancel: () => dispatch(hideModal()),
});

export default connect(null, mapDispatchToProps)(PublishWeddingWebsite);
